export const LISTA_ASSINATURAS = [
  { id: "1", descricao: "Não assina pela empresa" },
  { id: "2", descricao: "Assina isoladamente" },
  { id: "0", descricao: "Assina em conjunto" },
];

export const FAIXAS_FINANCEIRAS = [
  { id: "1", descricao: "Nenhum" },
  { id: "2", descricao: "Até R$ 5.000" },
  { id: "3", descricao: "De R$ 5.001 até R$ 10.000" },
  { id: "4", descricao: "De R$ 10.001 até R$ 30.000" },
  { id: "5", descricao: "De R$ 30.001 até R$ 50.000" },
  { id: "6", descricao: "De R$ 50.001 até R$ 100.000" },
  { id: "7", descricao: "Acima de R$ 100.001" },
];
